import { useReferralShareDialog } from '@/features/points/dialogs/referral-share-dialog/logic/useReferralShareDialog'
import { ReferralShareView } from '@/features/points/dialogs/referral-share-dialog/views/ReferralShareView'

export function ReferralShareDialogContentContainer() {
  const {
    referralCode,
    invitedUsers,
    season2TotalPoints,
    season3TotalPoints,
    pointsSeason,
    shareUrl,
    onCopy,
    onShare,
  } = useReferralShareDialog()

  return (
    <ReferralShareView
      referralCode={referralCode}
      invitedUsers={invitedUsers}
      season2TotalPoints={season2TotalPoints}
      season3TotalPoints={season3TotalPoints}
      pointsSeason={pointsSeason}
      onCopy={onCopy}
      shareUrl={shareUrl}
      onShare={onShare}
    />
  )
}
